import Homepage from "./Homepage"
import Page from "./Page"
export const nodeTypes = {
   homepage: Homepage,
   page: Page
}
